var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed, when, makeObservable } from 'mobx';
import { bound } from '../../utils/decorators/basic';
import { runtime } from '../runtime/Runtime';
export class ReactiveXa {
    xa;
    currentValue;
    lastFetchEnd;
    fetchingPromise;
    pollInterval;
    constructor({ xa, defaultValue = [], pollInterval }) {
        makeObservable(this);
        this.xa = xa;
        this.currentValue = defaultValue;
        this.pollInterval = pollInterval;
    }
    get isFetching() {
        return !!this.fetchingPromise;
    }
    async refetch() {
        await when(() => !this.isFetching);
        await this.fetchValue();
    }
    get isAvailable() {
        return typeof this.lastFetchEnd !== 'undefined';
    }
    get triggeredIsAvailable() {
        if (!this.lastFetchEnd && !this.isFetching) {
            this.fetchValue();
        }
        return this.isAvailable;
    }
    get streamedValue() {
        if (this.isFetching)
            return this.currentValue;
        if (!this.lastFetchEnd) {
            this.fetchValue();
        }
        return this.currentValue;
    }
    async fetchValue() {
        if (this.isFetching) {
            return await this.fetchingPromise;
        }
        if (this.pollInterval) {
            setTimeout(this.fetchValue, this.pollInterval);
        }
        const result = await this.provideFetchPromise();
        return result;
    }
    async provideFetchPromise() {
        const value = await this.xa();
        await runtime.runtimeScheduler.addToNextStateChange(() => {
            this.currentValue = value;
            this.fetchingPromise = undefined;
            this.lastFetchEnd = new Date();
        });
        return value;
    }
}
__decorate([
    observable.ref
], ReactiveXa.prototype, "currentValue", void 0);
__decorate([
    observable.ref
], ReactiveXa.prototype, "lastFetchEnd", void 0);
__decorate([
    observable.ref
], ReactiveXa.prototype, "fetchingPromise", void 0);
__decorate([
    bound
], ReactiveXa.prototype, "refetch", null);
__decorate([
    computed
], ReactiveXa.prototype, "isAvailable", null);
__decorate([
    computed
], ReactiveXa.prototype, "streamedValue", null);
__decorate([
    bound
], ReactiveXa.prototype, "fetchValue", null);
__decorate([
    bound
], ReactiveXa.prototype, "provideFetchPromise", null);
